import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { COLORS, FlexView, Row } from '@cuemath/comps';
import { Button as WCButton } from '@cuemath/web-comps';
import { Text } from '@cuemath/web-comps';

import { ReactComponent as CoderLoadingSVG } from 'img/coding-loader.svg';
import { ReactComponent as GrayStarSVG } from 'img/gray-star.svg';
import { useDispatch } from 'react-redux';
import { closeModal } from 'actions/modal';

const Wrapper = styled(FlexView)`
  height: 100%;
  padding: 24px;
  gap: 24px;
`;

const LoadingIcon = styled(CoderLoadingSVG)`
  width: 180px;
  height: 107px;
`;

const LoadingFailIcon = styled(GrayStarSVG)`
  width: 206px;
  height: 168ox;
`;

const LoadingMessageWrapper = styled(FlexView)`
  width: 100%;
`;

const LoadingMessage = styled(Text)`
  text-align: center;
`;

const ButtonWrapper = styled(Row)`
  padding: 0;
  gap: 16px;
  width: 100%;
`;

const Button = styled(WCButton)`
  width: ${({ width }) => width || 294}px;
  height: 40px;
`;

const loadScreenData = ({
  studentName,
  assignFailErrorMessage,
  assignTeacherViaDirectMapping = false,
}) => ({
  loading: {
    icon: <LoadingIcon />,
    message: {
      text1: 'Hold tight!',
      text2: assignTeacherViaDirectMapping
        ? `Creating Transfer Request...`
        : `We are looking for the best teacher to match ${studentName ||
            'Champ'}’s math needs`,
    },
  },
  loadingFailed: {
    icon: <LoadingFailIcon />,
    message: {
      text1: 'Oops!',
      text2:
        (typeof assignFailErrorMessage !== 'string' && assignFailErrorMessage?.reason) ||
        assignFailErrorMessage ||
        `Something went wrong.`,
    },
    button: true,
  },
});

const StudentTransferLoadScreens = ({
  type,
  studentName,
  onRetry,
  assignFailErrorMessage,
  assignTeacherViaDirectMapping = false,
}) => {
  const [screenToRender, setScreenToRender] = useState();

  const dispatch = useDispatch();

  const { icon, message, button } =
    loadScreenData({
      studentName,
      assignFailErrorMessage,
      assignTeacherViaDirectMapping,
    })[screenToRender] || {};
  const { text1, text2 } = message || {};

  const onClose = () => {
    dispatch(closeModal());
  };

  useEffect(() => {
    setScreenToRender(type);
  }, [type]);

  return (
    <Wrapper alignItems="center" justifyContent="center">
      {icon}

      <LoadingMessageWrapper alignItems="center" justifyContent="center">
        <LoadingMessage variant="body1Regular">{text1}</LoadingMessage>
        <LoadingMessage variant="body1Regular">{text2}</LoadingMessage>
      </LoadingMessageWrapper>

      {button && (
        <ButtonWrapper alignItems="center" justifyContent="space-between" nowrap>
          <Button
            size="small"
            label="Close"
            onClick={onClose}
            backgroundColor={COLORS.WHITE}
            width={140}
          />
          <Button size="small" label="Please try again" onClick={onRetry} />
        </ButtonWrapper>
      )}
    </Wrapper>
  );
};

export default StudentTransferLoadScreens;
